export {default as path} from "./path";



//////////////////
// WEBPACK FOOTER
// ./~/d3-path/src/index.js
// module id = YBK3
// module chunks = 0